import React, { useState, useEffect, useContext } from 'react';
import '../AddScript.css';
import config from '../config';
import { WebSocketContext } from "../WebSocketContext";
import { useTheme } from '../contexts/ThemeContext';
import { Bookmark, ArrowBack, Category } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';

const AddScript = () => {
  const { fetchUserScripts, userScripts } = useContext(WebSocketContext);
  const { isDarkMode } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const [scriptsData, setScriptData] = useState([]);
  const [segment, setSegment] = useState('MCX FUT');
  const [search, setSearch] = useState('');
  const [selectedStrike, setSelectedStrike] = useState('');
  const [optionType, setOptionType] = useState('All');
  const [existingScripts, setExistingScripts] = useState(new Set());
  const [showSegmentView, setShowSegmentView] = useState(true);
  
  // Get sticky type from navigation state
  const stickyType = location.state?.stickyType;
  const returnTo = location.state?.returnTo || '/';
  
  // Get current sticky scripts from localStorage
  const [currentStickyScripts, setCurrentStickyScripts] = useState(() => {
    try {
      const saved = localStorage.getItem('stickyScripts');
      return saved ? JSON.parse(saved) : { sticky1: null, sticky2: null };
    } catch (error) {
      console.error('Error loading sticky scripts:', error);
      return { sticky1: null, sticky2: null };
    }
  });

  useEffect(() => {
    if (Array.isArray(userScripts)) {
      const identifiers = new Set(userScripts.map(item => item.instrumentIdentifier));
      setExistingScripts(identifiers);
    }
  }, [userScripts]);

  useEffect(() => {
    setSelectedStrike('');
    const seg = getSegmentFromExchange(segment);
    const gby = seg !== 'OPTSTK';
    getScripts(seg, gby);
  }, [segment]);

  const getSegmentFromExchange = (exchange) => {
    switch (exchange) {
      case 'FUTCOM': return 'MCX FUT';
      case 'FUTSTK': return 'NSE FUT';
      case 'OPTSTK': return 'NSE OPT';
      case 'MCX FUT': return 'FUTCOM';
      case 'NSE FUT': return 'FUTSTK';
      case 'NSE OPT': return 'OPTSTK';
      default: return '';
    }
  };

  const getScripts = async (segment, gby) => {
    try {
      var jsn = "";
      if(segment=='FUTCOM' || segment=='FUTSTK'){
        jsn = { "exchange": segment};
      }else{
        jsn = gby ? { "exchange": segment, "groupBy": gby } : { "exchange": segment, "allstrike": true };
      }
      const response = await fetch(`${config.API_BASE_URL}scripts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer <YOUR_TOKEN>`
        },
        body: JSON.stringify(jsn),
      });
      const data = await response.json();
      setScriptData(data);
    } catch (error) {
      console.error('Error fetching scripts:', error);
    }
  };

  const addScriptToClient = async (script) => {
    try {
      const clientId = localStorage.getItem('userId');
      const jsn = { "clientId": clientId, "stockId": script.instrumentIdentifier };

      const response = await fetch(`${config.API_BASE_URL}addScriptToUser`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer <YOUR_TOKEN>`
        },
        body: JSON.stringify(jsn),
      });
      
      const data = await response.json();
      if (data.success) {
        // alert(`${script.scriptName} added successfully`);
        fetchUserScripts();
      }
    } catch (error) {
      console.error('Error adding script:', error);
    }
  };

  const deleteScriptFromUser = async (script) => {
    try {
        const clientId = localStorage.getItem('userId');
      const response = await fetch(`${config.API_BASE_URL}removeScriptFromUser`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          clientId: Number(clientId),
          stockId: Number(script.instrumentIdentifier)
        }),
      });

      const data = await response.json();
      if (data.success) {
        // alert(`${script.scriptName} removed successfully`);
        fetchUserScripts();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const removeScriptFromClient = async (script) => {
    try {
      const clientId = localStorage.getItem('userId');
      const jsn = { "clientId": Number(clientId), "stockId": Number(script.instrumentIdentifier) };
      console.log("data", jsn);

      const response = await fetch(`${config.API_BASE_URL}deleteScriptFromUser`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(jsn),
      });
      
      const data = await response.json();
      if (data.success) {
        alert(`${script.scriptName} removed successfully`);
        fetchUserScripts();
      }
    } catch (error) {
      console.error('Error adding script:', error);
    }
  };

  const getOPTSTKScripts = async (script) => {
    try {
      const jsn = { "scriptName": script.scriptName, "expiry": script.expiry, "cpboth": true };
      const response = await fetch(`${config.API_BASE_URL}OPTSTKStrikes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer <YOUR_TOKEN>`
        },
        body: JSON.stringify(jsn),
      });
      const data = await response.json();
      if(data){
        setScriptData(data);
      }
      else{
        setScriptData([]);
      }
    } catch (error) {
      console.error('Error fetching OPTSTK scripts:', error);
    }
  };

  const handleScriptClick = (script) => {
    // If this is for sticky script selection
    if (stickyType) {
      // Dispatch event to notify TitleBar about script selection
      const event = new CustomEvent('stickyScriptSelected', {
        detail: {
          stickyType: stickyType,
          selectedScript: script
        }
      });
      window.dispatchEvent(event);

      if (!existingScripts.has(script.instrumentIdentifier)) {
        addScriptToClient(script);
      }
      
      // Navigate back to the previous page
      navigate(returnTo);
      return;
    }

    // Original functionality for adding/removing scripts
    if (script.exchange === 'OPTSTK' && !selectedStrike) {
      setScriptData([]);
      setSelectedStrike(script);
      getOPTSTKScripts(script);
    } else {
        if (existingScripts.has(script.instrumentIdentifier)) {
          //callAnotherMethod(script);
          //alert("Already exist.");
          deleteScriptFromUser(script);
        }
        else {
          addScriptToClient(script);
        }
    }
  };

  const handleOptionTypeClick = (type) => {
    setOptionType(type);
  };

  const clearOPTSTK = () => {
    setScriptData([]);
    //setSegment('NSE OPT');
    setSelectedStrike('');
    const seg = getSegmentFromExchange(segment);
    const gby = seg !== 'OPTSTK';
    getScripts(seg, gby);
    setOptionType("All");
  };

  const handleSegmentSelect = (selectedSegment) => {
    setSegment(selectedSegment);
    setShowSegmentView(false);
  };

  const handleBackToSegments = () => {
    setShowSegmentView(true);
  };

  const filteredScripts = scriptsData
    .filter(script => getSegmentFromExchange(script.exchange) === segment)
    .filter(script => script.dispname.toLowerCase().includes(search.toLowerCase()))
    .filter(script => segment !== 'NSE OPT' || optionType === 'All' || script.call_put === optionType);

  return (
    <div className={`add-script-container ${isDarkMode ? 'dark-theme' : 'light-theme'}`} data-theme={isDarkMode ? 'dark' : 'light'}>
      {stickyType && (
        <div className="sticky-mode-header">
          <h2>Select Script for {stickyType === 'sticky1' ? 'Position 1' : 'Position 2'}</h2>
          <p>Choose a script to display in the top bar</p>
          {currentStickyScripts[stickyType] && (
            <div className="current-script-info">
              <span className="current-label">Currently selected:</span>
              <span className="current-script">{currentStickyScripts[stickyType].dispname}</span>
            </div>
          )}
        </div>
      )}
      
      {showSegmentView ? (
        // Segment Selection View
        <div className="add-script-segment-selection-view">
          <div className="add-script-segment-selection-header">
            <h2>Select Market Segment</h2>
            <p>Choose a market segment to view available scripts</p>
          </div>
          
          <div className="add-script-vertical-segment-buttons">
            {['MCX FUT', 'NSE FUT', 'NSE OPT'].map(seg => (
              <button
                key={seg}
                className="add-script-vertical-segment-button"
                onClick={() => handleSegmentSelect(seg)}
              >
                <Category className="add-script-segment-icon" />
                <div className="add-script-segment-content">
                  <span className="add-script-segment-name">{seg}</span>
                  <span className="add-script-segment-description">
                    {seg === 'MCX FUT' ? 'Commodity Futures' : 
                     seg === 'NSE FUT' ? 'Equity Futures' : 
                     'Equity Options'}
                  </span>
                </div>
              </button>
            ))}
          </div>
        </div>
      ) : (
        // Scripts List View
        <div className="add-script-scripts-list-view">
          <div className="add-script-scripts-header">
            <button className="add-script-back-button" onClick={handleBackToSegments}>
              <ArrowBack />
              Back to Segments
            </button>
            <h2>{segment} Scripts</h2>
          </div>
          
          <div className="add-script-search-container">
            <input
              type="text"
              placeholder="Search scripts..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="add-script-search-input"
            />
          </div>

          {selectedStrike && (
            <h4 onClick={clearOPTSTK}>
              {`< ${selectedStrike.scriptName}`}
              <p className="expiry">{selectedStrike.expiry}</p>
            </h4>
          )}

          {selectedStrike && segment === 'NSE OPT' && (
            <div className="add-script-option-type-buttons">
              {['All', 'CE', 'PE'].map(type => (
                <button
                  key={type}
                  className={`add-script-option-type-button ${optionType === type ? 'active' : ''}`}
                  onClick={() => handleOptionTypeClick(type)}
                >
                  {type === 'All' ? 'All' : type === 'CE' ? 'Call (CE)' : 'Put (PE)'}
                </button>
              ))}
            </div>
          )}

          <div className="script-list">
            {filteredScripts.map((script, index) => (
              <div
                key={index}
                className="add-script-script-item"
                onClick={() => handleScriptClick(script)}
              >
                <div className="add-script-script-info">
                  <div className="add-script-script-name">{script.scriptName}</div>
                  {selectedStrike && <span>&nbsp; {script.strike}</span>}
                  {selectedStrike && <span>&nbsp; {script.call_put}</span>}
                  <p className="expiry">{script.expiry}</p>
                </div>
                <div className="add-script-script-actions">
                  {existingScripts.has(script.instrumentIdentifier) ? (
                    <span className="add-script-existing-badge">Added</span>
                  ) : (
                    <button className="add-script-add-button">
                      <Category />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AddScript;
